/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListMembers } from "../funcs/accessListMembers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListMembersResult } from "../models/components/listmembersresult.js";
import {
  ListMembersRequest,
  ListMembersSecurity,
} from "../models/operations/listmembers.js";
import { unwrapAsync } from "../types/fp.js";
export type MembersQueryData = ListMembersResult;

export function prefetchMembers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListMembersRequest | undefined,
  security?: ListMembersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildMembersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildMembersQuery(
  client$: GramCore,
  request?: ListMembersRequest | undefined,
  security?: ListMembersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<MembersQueryData>;
} {
  return {
    queryKey: queryKeyMembers({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function membersQueryFn(ctx): Promise<MembersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListMembers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyMembers(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listMembers", parameters];
}
